/* Corner cart customisations. Only runs if the Corner widget is loaded;
   the Wellsons cart drawer (snippets/ws-cart-drawer.liquid) handles tiles units and vanity add-on notices itself. */
setTimeout(function () {
  if (typeof window.corner === 'undefined' || !window.corner.on) return;
  var corner = window.corner;
  corner.on("onCartEdit", function (params) {
    var editDetails = params.cartEdits[0].eventType;
    var variantDeleted = params.cartEdits[0].eventDetails.variantId;
    if (editDetails == "ITEM_DELETED") { itemDeleteWithNote(variantDeleted); } else { infoUpdate(); }
  });
  corner.on("refreshCart", function () { infoUpdate(); });
  corner.on("onCowiOpen", function () { infoUpdate(); });
  function infoUpdate() {
    var cartInfo = corner.get("cartInfo");
    $.each(cartInfo.items, function (k, v) {
      var tags = v.tags, product_id = v.productId;
      if ($("[data-product-id= " + product_id + " ] .corner-cowi-cart-item-qty span.param").length <= 0)
        if (tags.indexOf("sheet-tiles") != -1) {
          $("[data-product-id= " + product_id + " ] .corner-cowi-cart-item-variant-options").hide();
          $("[data-product-id= " + product_id + " ] .corner-cowi-cart-item-qty span").append("<span class='param'> Sheet</span>");
        } else if (tags.indexOf("tiles") != -1) {
          $("[data-product-id= " + product_id + " ] .corner-cowi-cart-item-variant-options").hide();
          $("[data-product-id= " + product_id + " ] .corner-cowi-cart-item-qty span").append("<span class='param'> Box</span>");
        }
    });
  }
  function itemDeleteWithNote(variantDeleted) {
    var cartInfo = corner.get("cartInfo");
    $.each(cartInfo.items, function (k, v) {
      var order_group = v.properties._io_parent_order_group;
      if (variantDeleted == v.variantId && order_group != null && order_group != undefined && order_group != "") {
        window.showCornerCartModal({
          title: "Please Note",
          description: "The product you have removed was part of a vanity options. Please note you won't get the removed product with your order.",
          isClosable: true,
          primaryCta: { text: "Got that!" }
        });
      }
    });
  }
}, 5000);
